import { format } from 'date-fns';
import { changeUpload, base64ToBlob } from 'utils';
import Upload from 'components/uploader/upload';

const getDocumentStateKeys = (label) => {
  switch (label) {
    case 'license':
      return { urlKey: 'licenseUrl', uuidKey: 'licenseID', errorKey: 'licenseIDError' }

    case 'payStub':
      return { urlKey: 'payStubUrl', uuidKey: 'payStubID', errorKey: 'payStubIDError' }

    case 'optional':
      return { urlKey: 'docUrl', uuidKey: 'docID' }

    case 'photoID':
      return { urlKey: 'docUrl', uuidKey: 'docID' }
  }
}

const changeUploadOptionalDoc = async (file, setter, state, key, id) => {
  const upload = new Upload(file)
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    const documents = state.map(doc => {
      if (id == doc.id) return { ...doc, [key]: reader.result }
      return doc
    })

    setter(documents)
  };

  await upload.upload()
  const result = { uuid: upload.uuid || null, url: reader.result || '' }

  return result
}

export default {
  'ModalBody.WebCamWrapper.WebCam': (_, _stateManager, interStateSetter) => {
    interStateSetter({  webCamLoading: false, })
  },
  'ModalBody.screenshotButton': async ({ screenshotRef, uploadedDoc, optionalDocs, photoIDs, toggleWebCam, disabled }, stateManager) => {
    if(disabled) return;
    const src = screenshotRef.current.getScreenshot();
    const blob = await base64ToBlob(src)
    blob.name = `AppRent_ScreenShot_${format(new Date(), "MM/dd/yyyy hh:mm:ss")}`

    if (toggleWebCam.label !== 'payStub') {
      const keys = getDocumentStateKeys(toggleWebCam.label)
      const result = await changeUploadOptionalDoc(blob, stateManager.setOptionalDocs, optionalDocs, keys.urlKey, toggleWebCam.docID)

      if (toggleWebCam.label === 'optional'){ 
        const documents = optionalDocs.map(doc => {
          if (toggleWebCam.docID == doc.id) return { ...doc, [keys.uuidKey]: result.uuid, [keys.urlKey]: result.url, docIDError: '', hasError: false };
          return doc;
        })
        stateManager.setOptionalDocs(documents);
      } else {
        const documents = photoIDs.map(doc => {
          if (toggleWebCam.docID == doc.id) return { ...doc, [keys.uuidKey]: result.uuid, [keys.urlKey]: result.url, docIDError: '', hasError: false };
          return doc;
        })
        stateManager.setPhotoIDs(documents);
      }

      if (!!result.uuid) stateManager.setToggleWebCam('')
      return
    }

    const { urlKey, uuidKey, errorKey } = getDocumentStateKeys(toggleWebCam.label)
    const { uuid, url } = await changeUpload(blob, stateManager.setUploadedDoc, uploadedDoc, urlKey)
    const updatedDoc = { ...uploadedDoc, [uuidKey]: uuid, [urlKey]: url, [errorKey]: '', hasError: false }
    stateManager.setUploadedDoc(updatedDoc)
    if (!!uuid) stateManager.setToggleWebCam('')
  }
}
